import { useQuery } from 'react-query'
import { fetchProjectParticipants } from './service'
import type { ParticipantsResponse, ProjectStudent, ProjectTeacher } from './types'

const STALE_TIME = 5 * 60 * 1000

const byName = (a: { fullName: string }, b: { fullName: string }) => a.fullName.localeCompare(b.fullName)

interface UseProjectParticipantsReturn {
  readonly creator: ProjectTeacher | null
  readonly coTeachers: readonly ProjectTeacher[]
  readonly students: readonly ProjectStudent[]
  readonly isLoading: boolean
  readonly isError: boolean
}

export const useProjectParticipants = (projectId: string | undefined): UseProjectParticipantsReturn => {
  const { data, isLoading, isError } = useQuery<ParticipantsResponse>(
    ['arc-project-participants', projectId],
    () => fetchProjectParticipants(projectId as string),
    {
      enabled: Boolean(projectId),
      staleTime: STALE_TIME,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  )

  const teachers = data?.teachers ?? []
  const creator = teachers.find(t => t.role === 'creator') ?? null
  const coTeachers = [...teachers].filter(t => t.role !== 'creator').sort(byName)
  const students = [...(data?.students ?? [])].sort(byName)

  return { creator, coTeachers, students, isLoading, isError }
}
